import { PublicPaymentMethodPropertyCode } from '../../enums/public-payment-method-property-code';
import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class PublicPaymentMethodPropertyResponse {
  @jsonMember(String)
  public readonly code!: PublicPaymentMethodPropertyCode;

  @jsonMember(String)
  public readonly name!: string;
}
